module.exports = __webpack_public_path__ + "img/logo_wave_white.820195eb.png";